module.exports = "<button type=\"button\" class=\"btn btn-primary transfer_to_erp_btn\" *ngIf=\"transfer_to_erp_btn\" (click)=\"submitToERP()\">Upload To ERP</button>"


//////////////////
// WEBPACK FOOTER
// /opt/tglfc/olap/salary_web/src/app/components/app-erp/app-erp-btn.component.html
// module id = ../../../../../src/app/components/app-erp/app-erp-btn.component.html
// module chunks = main